const map = {
  "//localhost:8600/": "saas/",
  "//localhost:8602/": "wdw/",
  "//localhost:9100/": "editor/", //画板
  "//localhost:9101/": "account/", //画板--账户中心

  /*==== 金坛二期 36段 ====*/
  "//localhost:3600/": "wdw/jtPvOptOverviewv2", // 金坛二期--光伏监控 运营总览-jtv2
  "//localhost:3601/": "wdw/jtPvAssetsLedgerv2", // 金坛二期--光伏监控 资产台账-jtv2
  "//localhost:3602/": "wdw/jtPvProfitMgrv2", // 金坛二期--光伏监控 成本收益管理-jtv2
  "//localhost:3603/": "wdw/jtEnergyAssetsViewv2", // 金坛二期--储能监控 资产总览-jtv2
  "//localhost:3604/": "wdw/jtChargeAssetsOverviewv2", // 金坛二期--充电监控 充电资产概览-jtv2
  "//localhost:3605/": "wdwScreen/#/JintanPanoramaScreenV2", // 金坛二期--资产运营全景大屏-jtv2
  "//localhost:3606/": "wdwScreen/#/JintanPvScreenV2", // 金坛二期--jrd-光伏资产大屏-jtv2
  "//localhost:3607/": "wdwScreen/#/JintanStorageScreenV2", // 金坛二期--jrd-储能资产大屏-jtv2
  "//localhost:3608/": "wdwScreen/#/JintanChargingScreenV2", // 金坛二期--jrd-充电资产大屏-jtv2
  "//localhost:3609/": "wdw/jtEnergyProfitv2", // 金坛二期--wwy-成本收益分析-jtv2
  "//localhost:3610/": "wdw/jtChargeOrderMgrv2", // 金坛二期--wwy-充电订单管理-jtv2
  "//localhost:3611/": "wdw/jtChargeProfitMgrv2", // 金坛二期--wwy-充电成本收益管理-jtv2
  "//localhost:3612/": "saas/jtHistoryEarnv2", // 金坛二期--基础设置-历史投资收益维护-jtv2
  "//localhost:3613/": "wdw/jtPowerYcv2", // 金坛二期--负荷预测分析-jtv2
  "//localhost:3614/": "wdw/jtStorageYcv2", // 金坛二期--新能源功率预测分析-jtv2

  /*==== 视频管理 37段 ====*/
  "//localhost:3700/": "saas/VideoDeviceMgr", // 视频管理--设备监控
  "//localhost:3701/": "saas/VideoList", // 视频管理--在线监测
  /*==== 碳排放管理 38段 ====*/
  "//localhost:3800/": "wdw/carbonConversion", // 碳排放管理--能耗碳排换算
  "//localhost:3801/": "wdw/carbonMonitor", // 碳排放管理--碳监测
  "//localhost:3802/": "wdw/carbonTroubleshoot", // 碳排放管理--碳排查
  "//localhost:3803/": "wdw/carbonReport", // 碳排放管理--碳报告
  "//localhost:3804/": "wdw/carbonAssetsManagement", // 碳排放管理--碳资产管理
  /*==== 财务结算中心 39段 ====*/
  "//localhost:3900/": "wdw/finaPvOverview", // 财务结算中心--光伏消纳运营看板
  "//localhost:3901/": "wdw/finaPvBillMgr", //财务结算中心--光伏消纳账单管理
  "//localhost:3902/": "wdw/finaPvClientMgr", // 财务结算中心--光伏消纳客户管理"
  "//localhost:3903/": "wdw/finaPvSettleReport", // 财务结算中心--光伏消纳经营报表"
  "//localhost:3904/": "wdw/finaPvSellerMgr", // 财务结算中心--光伏消纳销方管理"
  "//localhost:3905/": "wdw/finaPvMeterMgr", // 财务结算中心--光伏消纳抄表管理"
  "//localhost:3906/": "wdw/finaCnMeterMgr", // 财务结算中心--储能抄表管理
  "//localhost:3907/": "wdw/finaCnBillMgr", // 财务结算中心--储能账单管理
  "//localhost:3908/": "wdw/finaCnClientMgr", // 财务结算中心--储能购方信息管理
  "//localhost:3909/": "wdw/finaCnSellerMgr", // 财务结算中心--储能销方信息管理
  "//localhost:3910/": "wdw/finaGridPvMeterMgr", // 财务结算中心--光伏上网抄表管理
  "//localhost:3911/": "wdw/finaGridPvBillMgr", // 财务结算中心--光伏上网账单管理
  "//localhost:3912/": "wdw/finaGridPvClientMgr", // 财务结算中心--光伏上网购方信息管理
  "//localhost:3913/": "wdw/finaGridPvSellerMgr", // 财务结算中心--光伏上网销方信息管理
  "//localhost:3914/": "wdw/finaGridPvMeterMgrCzxny", // 财务结算中心--光伏上网抄表管理（常州新能源）
  "//localhost:3915/": "wdw/finaGridPvBillMgrCzxny", // 财务结算中心--光伏上网账单管理（常州新能源）
  "//localhost:3916/": "wdw/finaGridPvClientMgrCzxny", // 财务结算中心--光伏上网购方信息管理（常州新能源）
  "//localhost:3917/": "wdw/finaGridPvSellerMgrCzxny", // 财务结算中心--光伏上网销方信息管理（常州新能源）
  /*==== saas 基础设置 40段 ====*/
  "//localhost:4000/": "saas/sysUser", //基础设置--用户中心
  "//localhost:4001/": "saas/pmsClientInfo", //基础设置--客户信息管理
  "//localhost:4002/": "saas/pmsOrg", //基础设置--组织架构管理
  "//localhost:4003/": "saas/pmsDataGroup", //基础设置--数据分组管理
  "//localhost:4004/": "saas/pmsUserGroup", //基础设置--用户分组管理
  "//localhost:4005/": "saas/sysStation", //基础设置--岗位管理
  "//localhost:4006/": "saas/sysCompany", //基础设置--企业用户管理
  "//localhost:4007/": "saas/sysService", //基础设置--服务商用户管理
  "//localhost:4008/": "saas/pmsRole", //基础设置--角色管理
  "//localhost:4009/": "saas/elepBase", //基础设置--基本电价配置
  "//localhost:4010/": "saas/elepElectricity", //基础设置--电度电价配置
  "//localhost:4011/": "saas/elep", //基础设置--电度电价
  "//localhost:4012/": "saas/elepRatio", //基础设置--定比电价配置
  "//localhost:4013/": "saas/elepAdjustment", //基础设置--力调电价配置
  "//localhost:4014/": "saas/elepManage", //基础设置--电价方案管理
  "//localhost:4015/": "saas/bscDictionary", //基础设置--数据字典
  "//localhost:4016/": "saas/stationGraph", //基础设置--站点拓扑
  "//localhost:4017/": "saas/changeMeter", //基础设置--更换表计
  "//localhost:4018/": "saas/deviceTopu", //基础设置--设备拓扑
  "//localhost:4019/": "saas/electricitySharingManagement", //基础设置--电度公摊管理
  "//localhost:4020/": "saas/menuMgr", //基础设置--菜单管理
  "//localhost:4021/": "saas/GasDataConfig", //基础设置--售电、天然气、蒸汽管理
  "//localhost:4022/": "saas/TeleTopu", //基础设置--通讯拓扑
  "//localhost:4023/": "saas/sysUserOpen", //基础设置--账户管理(开放编辑)

  /*==== wdw 物联中心 41段 ====*/
  "//localhost:4100/": "wdw/intassetsMgr", //资产管理-网关资产管理
  "//localhost:4101/": "wdw/intsetting", //物联配置-采集设备拓扑
  "//localhost:4102/": "wdw/intgatewaygroup", //采集运维-网关群组配置
  "//localhost:4103/": "wdw/intinfo", //采集运维-物联信息总览
  "//localhost:4104/": "wdw/intgateways", //采集运维-网关列表
  "//localhost:4105/": "wdw/intgatewayjudge", //采集运维-网关智能研判
  "//localhost:4106/": "saas/showMeasureData", //采集运维-采集数据展示（saas的量测数据展示
  "//localhost:4107/": "wdw/intwebtest", //采集运维-webtest
  "//localhost:4108/": "saas/deviceModel", // 物联配置-客户物模拓扑
  "//localhost:4109/": "saas/deviceTemplate", // 物联配置-测点编码管理
  /*== 后付费51  ==*/
  "//localhost:5100/": "postpaid/overview", // 后付费--首页
  "//localhost:5101/": "postpaid/ownerinfo", // 后付费--业主信息
  "//localhost:5102/": "postpaid/ownerroom", // 后付费--业主房间关联
  "//localhost:5103/": "postpaid/bindrecord", // 后付费--绑定/解绑记录
  "//localhost:5104/": "postpaid/unbindrecord", // 后付费--解绑记录
  "//localhost:5105/": "postpaid/unbindaccount", // 后付费--销户销表
  "//localhost:5106/": "postpaid/rechargeinfo", // 后付费--充值信息
  "//localhost:5107/": "postpaid/areamanage", // 后付费--区域管理
  "//localhost:5108/": "postpaid/roommanage", // 后付费--房间管理
  "//localhost:5109/": "postpaid/collectormanage", // 后付费--采集器管理
  "//localhost:5110/": "postpaid/metermanage", // 后付费--表计管理
  "//localhost:5111/": "postpaid/roommeter", // 后付费--房间表计管理
  "//localhost:5112/": "postpaid/pricemanage", // 后付费--挂牌价管理
  "//localhost:5113/": "postpaid/billmanage", // 后付费--计费方案管理
  "//localhost:5114/": "postpaid/monthreport", // 后付费--月度结算单
  "//localhost:5115/": "postpaid/rechargeflow", // 后付费--业主流水
  "//localhost:5116/": "postpaid/allocation", // 后付费--分摊方案
  "//localhost:5117/": "postpaid/verifmanage", // 后付费--总表核查联
  "//localhost:5118/": "postpaid/unsettlebill", // 后付费--待结算账单
  "//localhost:5119/": "postpaid/SettleBill", // 后付费--已结算账单
  /*== 预付费52  ==*/
  "//localhost:5201/": "prepaid/ownerinfo", // 预付费--业主信息
  "//localhost:5202/": "prepaid/ownerroom", // 预付费--业主房间关联
  "//localhost:5206/": "prepaid/rechargeinfo", // 预付费--充值信息
  "//localhost:5215/": "prepaid/rechargeflow", // 预付费--业主流水
  "//localhost:5207/": "prepaid/areamanage", // 预付费--区域管理
  "//localhost:5208/": "prepaid/roommanage", // 预付费--房间管理
  "//localhost:5210/": "prepaid/metermanage", // 预付费--表计管理
  "//localhost:5211/": "prepaid/roommeter", // 预付费--房间表计管理
  "//localhost:5212/": "prepaid/pricemanage", // 预付费--挂牌价管理
  "//localhost:5213/": "prepaid/billmanage", // 预付费--计费方案管理
  /*== 能耗管理70  ==*/
  "//localhost:7000/": "wdw/eneoverview", // 能耗管理--概况
  "//localhost:7001/": "wdw/enebranch", // 能耗管理--支路能耗统计
  "//localhost:7002/": "wdw/enegroup", // 能耗管理--分组能耗统计
  "//localhost:7003/": "wdw/enebackstep", // 能耗管理--能耗折标分析
  "//localhost:7004/": "wdw/eneyoy", // 能耗管理--能耗同比
  "//localhost:7005/": "wdw/eneqoq", // 能耗管理--能耗环比
  "//localhost:7006/": "wdw/eneflow", // 能耗管理--能耗流向图
  "//localhost:7007/": "wdw/enesetting", // 能耗管理--分类分项配置
  /*== 能耗图61  ==*/
  "//localhost:6100/": "wdw/energyflowchart", // 能耗图--能源流向图
  "//localhost:6101/": "wdw/energyflowsetting", // 能耗图--能流配置
  /*== 运维管理71  ==*/
  "//localhost:7100/": "wdw/optdefect", // 运维管理--缺陷工单
  "//localhost:7101/": "wdw/opttourlist", // 运维管理--巡视工单列表
  "//localhost:7102/": "wdw/opttourset", // 运维管理--巡视工单配置
  "//localhost:7103/": "wdw/optservicelist", // 运维管理--维保工单列表
  "//localhost:7104/": "wdw/optserviceset", // 运维管理--维保工单配置
  "//localhost:7105/": "wdw/optgroupset", // 运维管理--排班管理
  "//localhost:7106/": "wdw/opterrormgr", // 运维管理--故障类型管理
  "//localhost:7109/": "wdw/optEmsCheck", // 运维管理--EMS启动自检

  "//localhost:7200/": "wdw/selfPvOverview", // 资产运营管理--自投光伏运营看板

  "//localhost:8601/": "wdw/overView", // 驾驶舱--微网概况
  "//localhost:8603/": "wdw/screen", // 驾驶舱--光储充大屏
  "//localhost:8604/": "wdw/electricityOverview",  // 配电监测--运行概况
  "//localhost:8605/": "wdw/powercspt", // 配电监测--用电量统计
  "//localhost:8606/": "wdw/powermgnt", // 配电监测--支路用电统计
  "//localhost:8607/": "wdw/transformer", // 配电监测--时段用电监测
  "//localhost:8608/": "wdw/trend", // 配电监测--时段用电对比
  "//localhost:8609/": "wdw/device", // 配电监测--设备用电对比
  "//localhost:8610/": "wdw/pvOverview", // 配电监测--运行概况
  "//localhost:8611/": "wdw/powerMonitor", // 配电监测--发用电量统计
  "//localhost:8612/": "wdw/inverterMonitor", // 配电监测--逆变器监测
  "//localhost:8613/": "wdw/contrastAnalysis", // 配电监测--逆变器对比
  "//localhost:8614/": "wdw/energyOverview", // 储能监测--运行概况
  "//localhost:8615/": "wdw/deviceMonitor", // 储能监测--pcs/bms
  "//localhost:8616/": "wdw/quantityMonitor", // 储能监测--充放用电量
  "//localhost:8617/": "wdw/chargingOverview", // 停充监测--运行概况
  "//localhost:8618/": "wdw/chargeData", // 停充监测--设备充电数据监控
  "//localhost:8619/": "wdw/chargeCapacity", // 停充监测--设备充电量监测
  "//localhost:8620/": "wdw/chargeStation", // 停充监测--充电站用电详情
  "//localhost:8621/": "wdw/strategyConfigure", // 策略配置--配置
  "//localhost:8622/": "wdw/strategyTable", // 策略配置--列表
  "//localhost:8623/": "wdw/strategyLog", // 策略配置--日志
  "//localhost:8624/": "wdw/manualControl", // 策略配置--手动控制
  "//localhost:8625/": "wdw/simple", // 驾驶舱--简版大屏
  "//localhost:8626/": "wdw/wideScreen", // 驾驶舱--光储充大屏20:9
  "//localhost:8627/": "wdw/energyReport", // 储能监测--报表统计
  "//localhost:8628/": "wdw/energyDataAnalysis", // 储能监测--数据分析
  "//localhost:8636/": "wdw/transanalysis", // 光伏监测--逆变器分析
  "//localhost:8637/": "wdw/inverterGroupAnalysis", // 光伏监测--逆变器组分析

  "//localhost:8700/": "wdw/powerqult", // 配电监测--电能质量监测
  "//localhost:8701/": "wdw/enviroment", // 配电监测--环境监测
  "//localhost:8702/": "wdw/compyoy", // 配电监测--同环比分析
  "//localhost:8703/": "wdw/reportdoc", // 配电监测--用电分析报告
  "//localhost:8704/": "wdw/reportfgp", // 配电监测--尖峰平谷报表
  "//localhost:8705/": "wdw/reportmeter", // 配电监测--远程抄表
  "//localhost:8706/": "wdw/reportload", // 配电监测--负荷极值报表
  "//localhost:8707/": "wdw/feecos", // 配电监测--力调电费分析
  "//localhost:8708/": "wdw/traiff", // 配电监测--基本电费分析
  "//localhost:8709/": "wdw/transfanaly", // 配电监测--变压器经济运行
  "//localhost:8633/": "wdw/costMonitor", //配电监测-度电成本监测

  "//localhost:8800/": "wdw/ChargeReport", // 停充监测--充电报表
  "//localhost:8801/": "wdw/ChargeAnalysis", // 停充监测--充电报表

  "//localhost:8900/": "vpp/overview", // 虚拟电厂--首页
  "//localhost:8901/": "vpp/plantmgr", // 虚拟电厂 --电厂管理
  "//localhost:8902/": "vpp/invitemgr", // 虚拟电厂 --邀约管理
  "//localhost:8903/": "vpp/replymgr", // 虚拟电厂 --调度管理
  "//localhost:8904/": "vpp/adjust", // 虚拟电厂 --可调节
  "//localhost:8905/": "vpp/userlog", // 虚拟电厂 --用户日志
  "//localhost:8906/": "vpp/monthbill", // 虚拟电厂 --月账单
  "//localhost:8907/": "vpp/clientbill", // 虚拟电厂 --客户对账单
  "//localhost:8908/": "vpp/clienteva", // 虚拟电厂 --客户调控能力
  "//localhost:8909/": "vpp/clientvppinvite", // 虚拟电厂 --客户企业邀约管理
  "//localhost:8910/": "vpp/clientvppbase", // 虚拟电厂 --客户端基线管理
  "//localhost:4001/": "vpp/contractmgr", // 虚拟电厂 --签约管理"

  "//localhost:8629/": "wdw/PeriodEleStatistics", // 光伏监测--分时段发用电量统计
  "//localhost:8630/": "wdw/strategyRecord", // 策略配置--策略记录
  "//localhost:8631/": "wdw/StrategyAssistant", // 策略配置--策略辅助列表


  /*==== wdw 新虚拟电厂模块 start ====*/
  "//localhost:9900/": "wdwvpp/overview", // 虚拟电厂--首页
  "//localhost:9901/": "wdwvpp/plantmgr", // 虚拟电厂 --电厂管理
  "//localhost:9902/": "wdwvpp/invitemgr", // 虚拟电厂 --邀约管理
  "//localhost:9903/": "wdwvpp/replymgr", // 虚拟电厂 --调度管理
  "//localhost:9904/": "wdwvpp/adjust", // 虚拟电厂 --可调节
  "//localhost:9905/": "wdwvpp/userlog", // 虚拟电厂 --用户日志
  "//localhost:9906/": "wdwvpp/monthbill", // 虚拟电厂 --月账单
  "//localhost:9907/": "wdwvpp/clientbill", // 虚拟电厂 --客户对账单
  "//localhost:9908/": "wdwvpp/clienteva", // 虚拟电厂 --客户调控能力
  "//localhost:9909/": "wdwvpp/clientvppinvite", // 虚拟电厂 --客户端企业邀约
  "//localhost:9910/": "wdwvpp/clientvppbase", // 虚拟电厂 -- 客户端基线管理
  "//localhost:9911/": "wdwvpp/contractmgr", // 虚拟电厂 -- 签约管理
  "//localhost:9912/": "wdwvpp/CapacityDetection", // 虚拟电厂 -- 能力检测
  /*==== wdw 新虚拟电厂模块 end ====*/
  "//localhost:8911/": "saas/listView", // saas --列表视图
  "//localhost:8912/": "saas/statisticsView", // saas --统计视图
  "//localhost:8913/": "saas/fullScreen", // saas --大屏展示
  "//localhost:8914/": "saas/photovoltaicMonitor", // saas --光伏监测
  "//localhost:8915/": "saas/stationReport", // saas --电站报表
  "//localhost:8916/": "saas/inverterReport", // saas --逆变器报表
  "//localhost:8917/": "saas/incomeReport", // saas --收益报表
  "//localhost:8918/": "saas/powerContrast", // saas --发电量对比
  "//localhost:8919/": "saas/comparative", // saas --同环比分析
  "//localhost:8920/": "saas/realStatus", // saas --运维实时状态
  "//localhost:8921/": "saas/alarm", // saas --运维告警
  "//localhost:8922/": "saas/income", // saas --收益计算
  "//localhost:8923/": "vpp/screenVpp", // 虚拟电厂 --大屏
  "//localhost:8924/": "saas/pvScreen", // saas --大屏展示(新能源集团)
  "//localhost:8925/": "saas/pvGeneratingEfficiencyMonitor", // saas --光伏站发电效率监测(新能源集团)


  "//localhost:9000/": "wdwScreen/#/home", // 微电网大屏
  "//localhost:9001/": "wdwScreen/#/widescreen", // 微电网大屏(宽屏)
  "//localhost:9002/": "wdwScreen/#/newScreen", // 微电网大屏(新版)
  "//localhost:9003/": "wdwScreen/#/newScreen2", // 微电网大屏(新版)
  "//localhost:9004/": "wdwScreen/#/screenV3", // 微电网大屏(新版)
  "//localhost:9005/": "wdwScreen/#/screenNewGcc", // 光储充大屏(新版)
  "//localhost:9006/": "wdwScreen/#/screenNewGcc2", // 光储充大屏(新版)
  "//localhost:9007/": "wdwScreen/#/JintanScreen", // 金坛大屏
  "//localhost:9008/": "wdwScreen/#/JintanSubsystemPv", // 金坛光伏子系统
  "//localhost:9009/": "wdwScreen/#/JintanSubsystemCn", // 金坛储能子系统
  "//localhost:9010/": "wdwScreen/#/JintanSubsystemCdz", // 金坛充电站子系统
  "//localhost:9011/": "wdwScreen/#/JintanSubsystemPark", // 金坛园区子系统
  "//localhost:9012/": "wdwScreen/#/JintanPanoramaScreen", // 金坛全景大屏
  "//localhost:9013/": "wdwScreen/#/AssetsManageScreen", // 资产管理大屏
  "//localhost:9014/": "wdwScreen/#/ChangZhouNewEnergyScreen", // 常州新能源大屏
  "//localhost:9015/": "wdwScreen/#/JintanVirtualPowerPlant", // 金坛虚拟电厂
  "//localhost:9016/": "wdwScreen/#/ShangHaiVpp", // 上海虚拟电厂
  "//localhost:9017/": "wdwScreen/#/KJCScreen", // 科教城大屏
  "//localhost:9018/": "wdwScreen/#/screenKHLY", // 凯宏铝业大屏
  "//localhost:9019/": "wdwScreen/#/ZshNationwide", // 中石化全国大屏
  "//localhost:9020/": "wdwScreen/#/screenV3Campus", // 长三角科创中心大屏


  "//localhost:9149/": "saas/alarmInfo", //告警信息
  "//localhost:9150/": "saas/video", //视频监控

  /*==== wdw 资产管理 ====*/
  "//localhost:9151/": "wdw/ZCEnergyOverView", //驾驶舱-能源概况
  "//localhost:9152/": "wdw/ZCPVOverView", //光伏-能源概况
  "//localhost:9153/": "wdw/ZCTrendAnalysis", //趋势分析
  "//localhost:9154/": "wdw/ZCRunReport", //运行报表
  "//localhost:9155/": "wdw/ZCStationReport", //电站报表
  "//localhost:9156/": "wdw/ZCIncomeReport", //收益报表
  "//localhost:9157/": "wdw/ZCPVIncomeCompute", //光伏-收益计算
  "//localhost:9158/": "wdw/ZCCNIncomeCompute", //储能-收益计算
  "//localhost:9159/": "wdw/ZCInvestIncome", //投资收益

  /*==== wdw 告警 ====*/
  "//localhost:9160/": "wdw/realTimeAlarm", //实时告警信息
  "//localhost:9161/": "wdw/alarmInfo", //告警信息

  /*==== wdw 结算中心 ====*/
  "//localhost:9162/": "wdw/monthlyLedger", //月度抄表台账
  "//localhost:9163/": "wdw/clientLedger", //客户结算台账
  "//localhost:9164/": "wdw/InvoiceVoid", //作废发票管理
  "//localhost:9165/": "wdw/apiCallRecords", //接口调用记录

  /*==== wdw 储能宝 92段 ====*/
  "//localhost:9200/": "wdw/calculation", //储能宝-储能测算
  "//localhost:9201/": "wdw/energyProject", //储能宝-储能项目
  "//localhost:9202/": "wdw/energyCabinet", //储能宝-储能柜
  "//localhost:9203/": "wdw/loadCurve", //储能宝-负荷曲线
  "//localhost:9204/": "wdw/energyConfig", //储能宝-储能配置
  "//localhost:9205/": "wdw/subsidyRrules", //储能宝-储能政府补贴规则

  /*==== wdw 报表管理 ====*/
  "//localhost:8632/": "wdw/deviceEfficiency", //报表管理-场站设备效率报表

  /*==== wdw 策略配置2.0 ====*/
  "//localhost:8634/": "wdw/strategyConfig", //策略配置2.0

  "//localhost:8635/": "wdw/electricityCanvas", //配电监测  实时一次图

  /*==== 设备资产 ====*/
  "//localhost:8500/": "asset/stationList", //场站生命周期
  "//localhost:8501/": "asset/deviceList", //资产设备台账
  "//localhost:8502/": "asset/addDeives", //批量新增资产设备
  "//localhost:8503/": "asset/deviceModel", //资产设备模板
  "//localhost:8504/": "asset/libraryList", //物料库列表
  "//localhost:8505/": "asset/attribute", //类型属性维护
  "//localhost:8506/": "asset/sim", //sim卡列表
};

const devMap = {
  "//localhost:8600/": "//localhost:8600/saas",
  /*==== 碳排放管理 38段 ====*/
  "//localhost:3800/": "//localhost:8602/wdw/carbonConversion", // 碳排放管理--能耗碳排换算
  "//localhost:3801/": "//localhost:8602/wdw/carbonMonitor", // 碳排放管理--能耗碳排换算
  "//localhost:3802/": "//localhost:8602/wdw/carbonTroubleshoot", // 碳排放管理--能耗碳排换算
  "//localhost:3803/": "//localhost:8602/wdw/carbonReport", // 碳排放管理--能耗碳排换算
  "//localhost:3804/": "//localhost:8602/wdw/carbonAssetsManagement", // 碳排放管理--能耗碳排换算
  /*==== 财务结算中心 39段 ====*/
  "//localhost:3900/": "//localhost:8602/wdw/finaPvOverview", // 财务结算中心--光伏消纳运营看板
  "//localhost:3901/": "//localhost:8602/wdw/finaPvBillMgr", //财务结算中心--光伏消纳账单管理
  "//localhost:3902/": "//localhost:8602/wdw/finaPvClientMgr", // 财务结算中心--光伏消纳客户管理"
  "//localhost:3903/": "//localhost:8602/wdw/finaPvSettleReport", // 财务结算中心--光伏消纳经营报表"
  "//localhost:3904/": "//localhost:8602/wdw/finaPvSellerMgr", // 财务结算中心--光伏消纳销方管理"
  "//localhost:3905/": "//localhost:8602/wdw/finaPvMeterMgr", // 财务结算中心--光伏消纳抄表管理"
  "//localhost:3906/": "//localhost:8602/wdw/finaCnMeterMgr", // 财务结算中心--储能抄表管理
  "//localhost:3907/": "//localhost:8602/wdw/finaCnBillMgr", // 财务结算中心--储能账单管理
  "//localhost:3908/": "//localhost:8602/wdw/finaCnClientMgr", // 财务结算中心--储能购方信息管理
  "//localhost:3909/": "//localhost:8602/wdw/finaCnSellerMgr", // 财务结算中心--储能销方信息管理
  "//localhost:3910/": "//localhost:8602/wdw/finaGridPvMeterMgr", // 财务结算中心--光伏上网抄表管理
  "//localhost:3911/": "//localhost:8602/wdw/finaGridPvBillMgr", // 财务结算中心--光伏上网账单管理
  "//localhost:3912/": "//localhost:8602/wdw/finaGridPvClientMgr", // 财务结算中心--光伏上网购方信息管理
  "//localhost:3913/": "//localhost:8602/wdw/finaGridPvSellerMgr", // 财务结算中心--光伏上网销方信息管理
  "//localhost:3914/": "//localhost:8602/wdw/finaGridPvMeterMgrCzxny", // 财务结算中心--光伏上网抄表管理（常州新能源）
  "//localhost:3915/": "//localhost:8602/wdw/finaGridPvBillMgrCzxny", // 财务结算中心--光伏上网账单管理（常州新能源）
  "//localhost:3916/": "//localhost:8602/wdw/finaGridPvClientMgrCzxny", // 财务结算中心--光伏上网购方信息管理（常州新能源）
  "//localhost:3917/": "//localhost:8602/wdw/finaGridPvSellerMgrCzxny", // 财务结算中心--光伏上网销方信息管理（常州新能源）
  /*==== wdw 物联中心 41段 ====*/
  "//localhost:4100/": "//localhost:8602/wdw/intassetsMgr", //资产管理-网关资产管理
  "//localhost:4101/": "//localhost:8602/wdw/intsetting", //物联配置-采集设备拓扑
  "//localhost:4102/": "//localhost:8602/wdw/intgatewaygroup", //采集运维-网关群组配置
  "//localhost:4103/": "//localhost:8602/wdw/intinfo", //采集运维-物联信息总览
  "//localhost:4104/": "//localhost:8602/wdw/intgateways", //采集运维-网关列表
  "//localhost:4105/": "//localhost:8602/wdw/intgatewayjudge", //采集运维-网关智能研判
  "//localhost:4106/": "//localhost:8600/saas/showMeasureData", //采集运维-采集数据展示（saas的量测数据展示
  "//localhost:4107/": "//localhost:8602/wdw/intwebtest", //采集运维-webtest
  "//localhost:4108/": "//localhost:8600/saas/deviceModel", // 物联配置-客户物模拓扑
  "//localhost:4109/": "//localhost:8600/saas/deviceTemplate", // 物联配置-测点编码管理

  /*== 后付费51  ==*/
  "//localhost:5100/": "//localhost:13001/postpaid/overview", // 后付费--首页
  "//localhost:5101/": "//localhost:13001/postpaid/ownerinfo", // 后付费--业主信息
  "//localhost:5102/": "//localhost:13001/postpaid/ownerroom", // 后付费--业主房间关联
  "//localhost:5103/": "//localhost:13001/postpaid/bindrecord", // 后付费--绑定/解绑记录
  "//localhost:5104/": "//localhost:13001/postpaid/unbindrecord", // 后付费--解绑记录
  "//localhost:5105/": "//localhost:13001/postpaid/unbindaccount", // 后付费--销户销表
  "//localhost:5106/": "//localhost:13001/postpaid/rechargeinfo", // 后付费--充值信息
  "//localhost:5107/": "//localhost:13001/postpaid/areamanage", // 后付费--区域管理
  "//localhost:5108/": "//localhost:13001/postpaid/roommanage", // 后付费--房间管理
  "//localhost:5109/": "//localhost:13001/postpaid/collectormanage", // 后付费--采集器管理
  "//localhost:5110/": "//localhost:13001/postpaid/metermanage", // 后付费--表计管理
  "//localhost:5111/": "//localhost:13001/postpaid/roommeter", // 后付费--房间表计管理
  "//localhost:5112/": "//localhost:13001/postpaid/pricemanage", // 后付费--挂牌价管理
  "//localhost:5113/": "//localhost:13001/postpaid/billmanage", // 后付费--计费方案管理
  "//localhost:5114/": "//localhost:13001/postpaid/monthreport", // 后付费--月度结算单
  "//localhost:5115/": "//localhost:13001/postpaid/rechargeflow", // 后付费--业主流水
  "//localhost:5116/": "//localhost:13001/postpaid/allocation", // 后付费--分摊方案
  "//localhost:5117/": "//localhost:13001/postpaid/verifmanage", // 后付费--总表核查联
  "//localhost:5118/": "//localhost:13001/postpaid/unsettlebill", // 后付费--待结算账单
  "//localhost:5119/": "//localhost:13001/postpaid/SettleBill", // 后付费--已结算账单

  /*== 预付费52  ==*/
  "//localhost:5201/": "//localhost:13001/prepaid/ownerinfo", // 预付费--业主信息
  "//localhost:5202/": "//localhost:13001/prepaid/ownerroom", // 预付费--业主房间关联
  "//localhost:5206/": "//localhost:13001/prepaid/rechargeinfo", // 预付费--充值信息
  "//localhost:5215/": "//localhost:13001/prepaid/rechargeflow", // 预付费--业主流水
  "//localhost:5207/": "//localhost:13001/prepaid/areamanage", // 预付费--区域管理
  "//localhost:5208/": "//localhost:13001/prepaid/roommanage", // 预付费--房间管理
  "//localhost:5210/": "//localhost:13001/prepaid/metermanage", // 预付费--表计管理
  "//localhost:5211/": "//localhost:13001/prepaid/roommeter", // 预付费--房间表计管理
  "//localhost:5212/": "//localhost:13001/prepaid/pricemanage", // 预付费--挂牌价管理
  "//localhost:5213/": "//localhost:13001/prepaid/billmanage", // 预付费--计费方案管理

  /*== 能耗图 61段  ==*/
  "//localhost:6100/": "//localhost:8602/wdw/energyflowchart", // 能耗图--能源流向图
  "//localhost:6101/": "//localhost:8602/wdw/energyflowsetting", // 能耗图--能流配置

  /*== 能耗管理 70段  ==*/
  "//localhost:7000/": "//localhost:8602/wdw/eneoverview", // 能耗管理--概况
  "//localhost:7001/": "//localhost:8602/wdw/enebranch", // 能耗管理--支路能耗统计
  "//localhost:7002/": "//localhost:8602/wdw/enegroup", // 能耗管理--分组能耗统计
  "//localhost:7003/": "//localhost:8602/wdw/enebackstep", // 能耗管理--能耗折标分析
  "//localhost:7004/": "//localhost:8602/wdw/eneyoy", // 能耗管理--能耗同比
  "//localhost:7005/": "//localhost:8602/wdw/eneqoq", // 能耗管理--能耗环比
  "//localhost:7006/": "//localhost:8602/wdw/eneflow", // 能耗管理--能耗流向图
  "//localhost:7007/": "//localhost:8602/wdw/enesetting", // 能耗管理--分类分项配置

  /*== 运维管理 71段  ==*/
  "//localhost:7100/": "//localhost:8602/wdw/optdefect", // 运维管理--缺陷工单
  "//localhost:7101/": "//localhost:8602/wdw/opttourlist", // 运维管理--巡视工单列表
  "//localhost:7102/": "//localhost:8602/wdw/opttourset", // 运维管理--巡视工单配置
  "//localhost:7103/": "//localhost:8602/wdw/optservicelist", // 运维管理--维保工单列表
  "//localhost:7104/": "//localhost:8602/wdw/optserviceset", // 运维管理--维保工单配置
  "//localhost:7105/": "//localhost:8602/wdw/optgroupset", // 运维管理--排班管理
  "//localhost:7106/": "//localhost:8602/wdw/opterrormgr", // 运维管理--故障类型管理
  "//localhost:7109/": "//localhost:8602/wdw/optEmsCheck", // 运维管理--EMS启动自检

  // "//localhost:7100/": "//localhost:8602/wdw/optoverview", // 运维管理--概况
  // "//localhost:7102/": "//localhost:8602/wdw/optrepair", // 运维管理--抢修工单
  // "//localhost:7104/": "//localhost:8602/wdw/optmaintenance", // 运维管理--维保工单
  // "//localhost:7105/": "//localhost:8602/wdw/optproject", // 运维管理--项目配置
  // "//localhost:7106/": "//localhost:8602/wdw/opttemplate", // 运维管理--模板配置
  // "//localhost:7107/": "//localhost:8602/wdw/optplan", // 运维管理--巡视计划
  // "//localhost:7108/": "//localhost:8602/wdw/optgroup", // 运维管理--运维班组

  "//localhost:8601/": "//localhost:8602/wdw/overView", // 驾驶舱--微网概况
  "//localhost:8603/": "//localhost:8602/wdw/screen", // 驾驶舱--光储充大屏
  "//localhost:8626/": "//localhost:8602/wdw/wideScreen", // 驾驶舱--光储充大屏20:9
  "//localhost:8625/": "//localhost:8602/wdw/simple", // 驾驶舱--简版大屏

  "//localhost:8604/": "//localhost:8602/wdw/electricityOverview",  // 配电监测--运行概况
  "//localhost:8605/": "//localhost:8602/wdw/powercspt", // 配电监测--用电量统计
  "//localhost:8606/": "//localhost:8602/wdw/powermgnt", // 配电监测--支路用电统计
  "//localhost:8607/": "//localhost:8602/wdw/transformer", // 配电监测--时段用电监测
  "//localhost:8608/": "//localhost:8602/wdw/trend", // 配电监测--时段用电对比
  "//localhost:8609/": "//localhost:8602/wdw/device", // 配电监测--设备用电对比
  "//localhost:8700/": "//localhost:8602/wdw/powerqult", // 配电监测--电能质量监测
  "//localhost:8701/": "//localhost:8602/wdw/enviroment", // 配电监测--环境监测
  "//localhost:8702/": "//localhost:8602/wdw/compyoy", // 配电监测--同环比分析
  "//localhost:8703/": "//localhost:8602/wdw/reportdoc", // 配电监测--用电分析报告
  "//localhost:8704/": "//localhost:8602/wdw/reportfgp", // 配电监测--尖峰平谷报表
  "//localhost:8705/": "//localhost:8602/wdw/reportmeter", // 配电监测--远程抄表
  "//localhost:8706/": "//localhost:8602/wdw/reportload", // 配电监测--负荷极值报表
  "//localhost:8707/": "//localhost:8602/wdw/feecos", // 配电监测--力调电费分析
  "//localhost:8708/": "//localhost:8602/wdw/traiff", // 配电监测--基本电费分析
  "//localhost:8709/": "//localhost:8602/wdw/transfanaly", // 配电监测--变压器经济运行
  "//localhost:8633/": "//localhost:8602/wdw/costMonitor", //配电监测-度电成本监测

  "//localhost:8610/": "//localhost:8602/wdw/pvOverview", // 光伏监测--运行概况
  "//localhost:8611/": "//localhost:8602/wdw/powerMonitor", // 光伏监测--发用电量统计
  "//localhost:8612/": "//localhost:8602/wdw/inverterMonitor", // 光伏监测--逆变器监测
  "//localhost:8613/": "//localhost:8602/wdw/contrastAnalysis", // 光伏监测--逆变器对比
  "//localhost:8629/": "//localhost:8602/wdw/PeriodEleStatistics", // 光伏监测--分时段发用电量统计
  "//localhost:8636/": "//localhost:8602/wdw/transanalysis", // 光伏监测--逆变器分析
  "//localhost:8637/": "//localhost:8602/wdw/inverterGroupAnalysis", // 光伏监测--逆变器组分析

  "//localhost:8614/": "//localhost:8602/wdw/energyOverview", // 储能监测--运行概况
  "//localhost:8615/": "//localhost:8602/wdw/deviceMonitor", // 储能监测--pcs/bms
  "//localhost:8616/": "//localhost:8602/wdw/quantityMonitor", // 储能监测--充放用电量
  "//localhost:8617/": "//localhost:8602/wdw/chargingOverview", // 停充监测--运行概况
  "//localhost:8618/": "//localhost:8602/wdw/chargeData", // 停充监测--设备充电数据监控
  "//localhost:8619/": "//localhost:8602/wdw/chargeCapacity", // 停充监测--设备充电量监测
  "//localhost:8620/": "//localhost:8602/wdw/chargeStation", // 停充监测--充电站用电详情
  "//localhost:8621/": "//localhost:8602/wdw/strategyConfigure", // 策略配置--配置
  "//localhost:8622/": "//localhost:8602/wdw/strategyTable", // 策略配置--列表
  "//localhost:8623/": "//localhost:8602/wdw/strategyLog", // 策略配置--日志
  "//localhost:8624/": "//localhost:8602/wdw/manualControl", // 策略配置--手动控制
  "//localhost:8630/": "//localhost:8602/wdw/strategyRecord", // 策略配置--策略记录
  "//localhost:8631/": "//localhost:8602/wdw/StrategyAssistant", // 策略配置--策略辅助列表
  "//localhost:8627/": "//localhost:8602/wdw/energyReport", // 储能监测--报表统计
  "//localhost:8628/": "//localhost:8602/wdw/energyDataAnalysis", // 储能监测--数据分析

  "//localhost:8800/": "//localhost:8602/wdw/ChargeReport", // 停充监测--充电报表
  "//localhost:8801/": "//localhost:8602/wdw/ChargeAnalysis", // 停充监测--充电报表


  /*==== wdw 资产管理 ====*/
  "//localhost:9151/": "//localhost:8602/wdw/ZCEnergyOverView", //驾驶舱-能源概况
  "//localhost:9152/": "//localhost:8602/wdw/ZCPVOverView", //光伏-能源概况
  "//localhost:9153/": "//localhost:8602/wdw/ZCTrendAnalysis", //趋势分析
  "//localhost:9154/": "//localhost:8602/wdw/ZCRunReport", //运行报表
  "//localhost:9155/": "//localhost:8602/wdw/ZCStationReport", //电站报表
  "//localhost:9156/": "//localhost:8602/wdw/ZCIncomeReport", //收益报表
  "//localhost:9157/": "//localhost:8602/wdw/ZCPVIncomeCompute", //光伏-收益计算
  "//localhost:9158/": "//localhost:8602/wdw/ZCCNIncomeCompute", //储能-收益计算
  "//localhost:9159/": "//localhost:8602/wdw/ZCInvestIncome", //投资收益

  /*==== wdw 告警 ====*/
  "//localhost:9160/": "//localhost:8602/wdw/realTimeAlarm", //实时告警信息
  "//localhost:9161/": "//localhost:8602/wdw/alarmInfo", //告警信息

  /*==== wdw 结算中心 ====*/
  "//localhost:9162/": "//localhost:8602/wdw/monthlyLedger", //月度抄表台账
  "//localhost:9163/": "//localhost:8602/wdw/clientLedger", // 客户结算台账
  "//localhost:9164/": "//localhost:8602/wdw/InvoiceVoid", // 作废发票管理
  "//localhost:9165/": "//localhost:8602/wdw/apiCallRecords", // 接口调用记录

  "//localhost:8900/": "//localhost:8603/vpp/overview", // 虚拟电厂--首页
  "//localhost:8901/": "//localhost:8603/vpp/plantmgr", // 虚拟电厂 --电厂管理
  "//localhost:8902/": "//localhost:8603/vpp/invitemgr", // 虚拟电厂 --邀约管理
  "//localhost:8903/": "//localhost:8603/vpp/replymgr", // 虚拟电厂 --调度管理
  "//localhost:8904/": "//localhost:8603/vpp/adjust", // 虚拟电厂 --可调节
  "//localhost:8905/": "//localhost:8603/vpp/userlog", // 虚拟电厂 --用户日志
  "//localhost:8906/": "//localhost:8603/vpp/monthbill", // 虚拟电厂 --月账单
  "//localhost:8907/": "//localhost:8603/vpp/clientbill", // 虚拟电厂 --客户对账单
  "//localhost:8908/": "//localhost:8603/vpp/clienteva", // 虚拟电厂 --客户调控能力
  "//localhost:8909/": "//localhost:8603/vpp/clientvppinvite", // 虚拟电厂 --客户端企业邀约
  "//localhost:8910/": "//localhost:8603/vpp/clientvppbase", // 虚拟电厂 -- 客户端基线管理
  "//localhost:4001/": "//localhost:8603/vpp/contractmgr", // 虚拟电厂 --签约管理"
  "//localhost:8923/": "//localhost:8603/vpp/screen", // 虚拟电厂 -- 大屏




  /*==== wdw 新虚拟电厂模块 start ====*/
  "//localhost:9900/": "//localhost:8603/wdwvpp/overview", // 虚拟电厂--首页
  "//localhost:9901/": "//localhost:8603/wdwvpp/plantmgr", // 虚拟电厂 --电厂管理
  "//localhost:9902/": "//localhost:8603/wdwvpp/invitemgr", // 虚拟电厂 --邀约管理
  "//localhost:9903/": "//localhost:8603/wdwvpp/replymgr", // 虚拟电厂 --调度管理
  "//localhost:9904/": "//localhost:8603/wdwvpp/adjust", // 虚拟电厂 --可调节
  "//localhost:9905/": "//localhost:8603/wdwvpp/userlog", // 虚拟电厂 --用户日志
  "//localhost:9906/": "//localhost:8603/wdwvpp/monthbill", // 虚拟电厂 --月账单
  "//localhost:9907/": "//localhost:8603/wdwvpp/clientbill", // 虚拟电厂 --客户对账单
  "//localhost:9908/": "//localhost:8603/wdwvpp/clienteva", // 虚拟电厂 --客户调控能力
  "//localhost:9909/": "//localhost:8603/wdwvpp/clientvppinvite", // 虚拟电厂 --客户端企业邀约
  "//localhost:9910/": "//localhost:8603/wdwvpp/clientvppbase", // 虚拟电厂 -- 客户端基线管理
  "//localhost:9923/": "//localhost:8603/wdwvpp/screen", // 虚拟电厂 -- 大屏
  "//localhost:9911/": "//localhost:8603/wdwvpp/contractmgr", // 虚拟电厂 -- 签约管理
  "//localhost:9912/": "//localhost:8603/wdwvpp/CapacityDetection", // 虚拟电厂 -- 能力检测
  /*==== wdw 新虚拟电厂模块 end ====*/

  "//localhost:9000/": "//localhost:8601/wdwScreen/#/home", // 金瑞达 --首页
  "//localhost:9001/": "//localhost:8601/wdwScreen/#/widescreen", // 金瑞达 --首页(适配集控大厅的宽屏幕)
  "//localhost:9002/": "//localhost:8601/wdwScreen/#/newScreen", // 新版大屏
  "//localhost:9003/": "//localhost:8601/wdwScreen/#/newScreen2", // 新版大屏
  "//localhost:9004/": "//localhost:8601/wdwScreen/#/screenV3", // 新版大屏
  "//localhost:9005/": "//localhost:8601/wdwScreen/#/screenNewGcc", // 新版光储充大屏
  "//localhost:9006/": "//localhost:8601/wdwScreen/#/screenNewGcc2", // 新版光储充大屏
  "//localhost:9007/": "//localhost:8601/wdwScreen/#/JintanScreen", // 金坛大屏
  "//localhost:9008/": "//localhost:8601/wdwScreen/#/JintanSubsystemPv", // 金坛光伏子系统
  "//localhost:9009/": "//localhost:8601/wdwScreen/#/JintanSubsystemCn", // 金坛储能子系统
  "//localhost:9010/": "//localhost:8601/wdwScreen/#/JintanSubsystemCdz", // 金坛充电站子系统
  "//localhost:9011/": "//localhost:8601/wdwScreen/#/JintanSubsystemPark", // 金坛园区子系统
  "//localhost:9012/": "//localhost:8601/wdwScreen/#/JintanPanoramaScreen", // 金坛全景大屏
  "//localhost:9013/": "//localhost:8601/wdwScreen/#/AssetsManageScreen", // 资产管理大屏
  "//localhost:9014/": "//localhost:8601/wdwScreen/#/ChangZhouNewEnergyScreen", // 常州新能源大屏
  "//localhost:9015/": "//localhost:8601/wdwScreen/#/JintanVirtualPowerPlant", // 金坛虚拟电厂大屏
  "//localhost:9016/": "//localhost:8601/wdwScreen/#/ShangHaiVpp", // 上海虚拟电厂大屏
  "//localhost:9017/": "//localhost:8601/wdwScreen/#/KJCScreen", // 科教城大屏
  "//localhost:9018/": "//localhost:8601/wdwScreen/#/screenKHLY", // 客户来源大屏
  "//localhost:9019/": "//localhost:8601/wdwScreen/#/ZshNationwide", // 中石化全国大屏
  "//localhost:9020/": "//localhost:8601/wdwScreen/#/screenV3Campus", // 长三角科创中心大屏

  "//localhost:8911/": "//localhost:8600/saas/listView", // saas --列表视图
  "//localhost:8912/": "//localhost:8600/saas/statisticsView", // saas --统计视图
  "//localhost:8913/": "//localhost:8600/saas/fullScreen", // saas --大屏展示
  "//localhost:8914/": "//localhost:8600/saas/photovoltaicMonitor", // saas --光伏监测
  "//localhost:8915/": "//localhost:8600/saas/stationReport", // saas --电站报表
  "//localhost:8916/": "//localhost:8600/saas/inverterReport", // saas --逆变器报表
  "//localhost:8917/": "//localhost:8600/saas/incomeReport", // saas --收益报表
  "//localhost:8918/": "//localhost:8600/saas/powerContrast", // saas --发电量对比
  "//localhost:8919/": "//localhost:8600/saas/comparative", // saas --同环比分析
  "//localhost:8920/": "//localhost:8600/saas/realStatus", // saas --运维实时状态
  "//localhost:8921/": "//localhost:8600/saas/alarm", // saas --运维告警
  "//localhost:8922/": "//localhost:8600/saas/income", // saas --收益计算
  "//localhost:8924/": "//localhost:8600/saas/pvScreen", // saas --大屏展示(新能源集团)
  "//localhost:8925/": "//localhost:8600/saas/pvGeneratingEfficiencyMonitor", // saas --光伏站发电效率监测(新能源集团)
  "//localhost:9150/": "//localhost:8600/saas/video", //视频监控

  /*==== wdw 储能宝 92段 ====*/
  "//localhost:9200/": "//localhost:8602/wdw/calculation", //储能宝-储能测算
  "//localhost:9201/": "//localhost:8602/wdw/energyProject", //储能宝-储能项目
  "//localhost:9202/": "//localhost:8602/wdw/energyCabinet", //储能宝-储能柜
  "//localhost:9203/": "//localhost:8602/wdw/loadCurve", //储能宝-负荷曲线
  "//localhost:9204/": "//localhost:8602/wdw/energyConfig", //储能宝-储能配置
  "//localhost:9205/": "//localhost:8602/wdw/subsidyRrules", //储能宝-储能政府补贴规则

  "//localhost:9100/": "//localhost:88/", //画板

  /*==== wdw 报表管理 ====*/
  "//localhost:8632/": "//localhost:8602/wdw/deviceEfficiency", //报表管理-场站设备效率报表

  /*==== wdw 策略配置2.0 ====*/
  "//localhost:8634/": "//localhost:8602/wdw/strategyConfig", //策略配置2.0

  "//localhost:8635/": "//localhost:8602/wdw/electricityCanvas", //配电监测  实时一次图

  /*==== 设备资产 ====*/
  "//localhost:8500/": "//localhost:8202/asset/stationList", //场站生命周期
  "//localhost:8501/": "//localhost:8202/asset/deviceList", //资产设备台账
  "//localhost:8502/": "//localhost:8202/asset/addDeives", //批量新增资产设备
  "//localhost:8503/": "//localhost:8202/asset/deviceModel", //资产设备模板
  "//localhost:8504/": "//localhost:8202/asset/libraryList", //物料库列表
  "//localhost:8505/": "//localhost:8202/asset/attribute", //类型属性维护
  "//localhost:8506/": "//localhost:8202/asset/sim", //sim卡列表
}

export default function hostMap(host) {
  if (process.env.NODE_ENV === "development") return devMap[host];
  if (process.env.NODE_ENV === "production") {
    return `${window.location.protocol}//${window.location.host}/${map[host]}`;
  }
  return host;
}
